import React, {useEffect, useState} from 'react';
import cl from '../../styles/TeachersPage.module.css'
import parent from '../../styles/StudentsPage.module.css'
import pic from "../../Assets/Education.svg";
import MyBanner from "../../components/UI/MyBanner/MyBanner";
import SearchAndFilter from "../../components/UI/SearchAndFilter/SearchAndFilter";
import UserItem from "../../components/UI/UserItem/UserItem";
import MyPagination from "../../components/UI/MyPagination/MyPagination";
import Service from "../../API/Service";


const TeachersPage = () => {
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [info, setInfo] = useState([]);
    const [filters, setFilters] = useState({
        isBlocked: "",
        searchText: "",
        departmentId: "",
    });

    const title = 'Header of management page bla bla'
    const desc = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. '
    const entity = 'teachers'
    const deleteText = 'Are you sure you want to delete this teacher? This action cannot be undone.'

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Service.getUsers(entity, filters, page); // Передаём фильтры
                const content = response.data.content;
                setInfo(content);
                setTotalPages(response.data.totalPages)
            } catch (error) {
                console.error("Ошибка при загрузке данных:", error);
                setInfo([]);
            }
        };
        fetchData();
    }, [filters, page]);

    return (
        <div className={parent.wrap}>
            <MyBanner
                background={'linear-gradient(137.35deg, #60A5FA -8.87%, #1D4ED8 86.92%)'}
                title={title}
                desc={desc}
                image={pic}
                entity={entity}
                isBlue={true}
            />
            <div className={parent.content}>
                <SearchAndFilter
                    filters={filters}
                    setFilters={setFilters}
                    entity={entity}
                />
                <div className={parent.lists}>
                    {info.map((item, index) =>(
                        <UserItem
                            key={index}
                            id={item.id}
                            name={item.name}
                            surname={item.surname}
                            entity={entity}
                            setData={setInfo}
                            text={deleteText}
                            dep={item.departmentName}
                        />
                    ))}
                </div>
                <MyPagination totalPages={totalPages} currentPage={page} onPageChange={setPage}/>
            </div>
        </div>
    );
};

export default TeachersPage;